import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@/components/ui/card';
import { AuthLayout } from '@/components/layout/auth-layout';
import { apiClient } from '@/lib/api-client';

type State = 'loading' | 'ok' | 'error';

function extractApiMessage(err: unknown, fallback: string): string {
  const body = (err as { body?: unknown })?.body;
  const raw = (body as { message?: unknown })?.message;
  if (typeof raw === 'string') return raw;
  return (err as Error)?.message ?? fallback;
}

export default function VerifyEmailPage() {
  const { token = '' } = useParams<{ token: string }>();
  const [state, setState] = useState<State>('loading');
  const [errorMsg, setErrorMsg] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    void (async () => {
      try {
        await apiClient.confirmEmail(token);
        if (!cancelled) setState('ok');
      } catch (err) {
        if (!cancelled) {
          setState('error');
          setErrorMsg(extractApiMessage(err, 'Token inválido'));
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [token]);

  return (
    <AuthLayout>
      <Card>
        <CardHeader>
          <CardTitle>
            {state === 'loading' && 'Verificando e-mail...'}
            {state === 'ok' && 'E-mail verificado'}
            {state === 'error' && 'Falha na verificação'}
          </CardTitle>
          <CardDescription>
            {state === 'loading' && 'Estamos validando seu link.'}
            {state === 'ok' && 'Sua conta esta ativa.'}
            {state === 'error' && (errorMsg ?? 'Token inválido ou expirado')}
          </CardDescription>
        </CardHeader>
        <CardContent>
          <Link
            to="/sign-in"
            className="text-sm text-[var(--fg-muted)] hover:underline"
          >
            Ir para o login
          </Link>
        </CardContent>
      </Card>
    </AuthLayout>
  );
}
